// extracted by mini-css-extract-plugin
export default {"ToggleButton":"Sort_ToggleButton__DxXgK"};